import { render, staticRenderFns } from "./AphtListCreated.vue?vue&type=template&id=3e11bd0f&"
import script from "./AphtListCreated.vue?vue&type=script&lang=js&"
export * from "./AphtListCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports